import type { ReactNode } from "react"
import { AuthDeviceMatrix } from "./AuthDeviceMatrix"
import { AuthQuoteCarousel } from "./AuthQuoteCarousel"
import styles from "./AuthPageContainer.module.css"

export const AuthPageContainer = ({ children }: { children: ReactNode }) => (
  <main className={styles.page}>
    <aside
      className={styles.visual}
      aria-label="Seam customers and connected devices"
    >
      <AuthDeviceMatrix>
        <AuthQuoteCarousel />
      </AuthDeviceMatrix>
    </aside>
    <section className={styles.auth} aria-label="Your Seam account">
      <div className={styles.form}>{children}</div>
    </section>
  </main>
)
